import { APP_ID, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { Object } from 'aws-sdk/clients/s3';
import { filter } from "rxjs/operators";
import { UserService } from "../../../shared/services/user/user.service";
import { NgxSpinnerService } from 'ngx-spinner';

declare var $: any;

@Component({
    selector: 'app-application-form',
    templateUrl: './application-form.component.html',
    styleUrls: ['./application-form.component.scss']
})
export class ApplicationFormComponent implements OnInit {
    person = JSON.parse(localStorage.getItem('person'));
    token = localStorage.getItem('token');
    value: number = 0;
    arrow: boolean = false;
    isRenewalApplication = false;
    checkSubmitApplication = false;
    currentApplicationDetails: any;

    constructor(private userService: UserService, private spinner: NgxSpinnerService,
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: Object,
        @Inject(APP_ID) private appId: string) {
        this.router.events.pipe(
            filter((event: RouterEvent) => event instanceof NavigationEnd)
        ).subscribe((data: any) => {
            this.activatedTab();
        });

        let interval = setInterval(() => {
            this.value = this.value + Math.floor(Math.random() * 10) + 1;
            if (this.value >= 100) {
                this.value = 100;
                clearInterval(interval);
            }
        }, 2000);
    }

    ngOnInit() {
        this.userService.setCurrentLicenceType();
        this.currentApplicationDetails = this.userService.getCurrentLicenceType();
        if (this.currentApplicationDetails.isRenewLicensingApplication === true) {
            this.isRenewalApplication = true;
        } else {
            this.isRenewalApplication = false;
        }
        if (this.currentApplicationDetails.isLicensingApplicationSubmitted === true && this.currentApplicationDetails.isMedicalSubmitted === true && this.currentApplicationDetails.isReferencesSubmitted === true) {
            this.checkSubmitApplication = true;
        }
        this.router.navigate(['application-form/profile-details']);
        this.getApplicationProgressData();
    }

    // activatedTab() {
    //     $('.nav-link').removeClass('active');
    //     if (this.router.url.match('/profile-details')) {
    //         $('#profile-tab').addClass('active');
    //     } else if (this.router.url.match('/principal-yard')) {
    //         $('#principalYard-tab').addClass('active');
    //     } else if (this.router.url.match('/additional-yard')) {
    //         $('#additionalYard-tab').addClass('active');
    //     } else if (this.router.url.match('/experience-pt-1')) {
    //         $('#experience-tab').addClass('active');
    //     } else if (this.router.url.match('/fit-and-proper-person')) {
    //         $('#fitProperPerson-tab').addClass('active');
    //     } else if (this.router.url.match('/data-protection')) {
    //         $('#dataprotection-tab').addClass('active');
    //     } else if (this.router.url.match('/medical')) {
    //         $('#medical-tab').addClass('active');
    //     } else if (this.router.url.match('/concussion')) {
    //         $('#concussion-tab').addClass('active');
    //     } else if (this.router.url.match('/fixtures')) {
    //         $('#fixtures-tab').addClass('active');
    //     } else if (this.router.url.match('/fiscal')) {
    //         $('#fiscal-tab').addClass('active');
    //     } else if (this.router.url.match('/insurance')) {
    //         $('#insurance-tab').addClass('active');
    //     } else if (this.router.url.match('/employee-card-1')) {
    //         $('#employee-card1-tab').addClass('active');
    //     } else if (this.router.url.match('/personnel')) {
    //         $('#personnel-tab').addClass('active');
    //     } else if (this.router.url.match('/facilities')) {
    //         $('#facilities-tab').addClass('active');
    //     } else if (this.router.url.match('/declaration')) {
    //         $('#declaration-tab').addClass('active');
    //     } else if (this.router.url.match('/summary')) {
    //         $('#summary-tab').addClass('active');
    //     } else if (this.router.url.match('/sbs-agreement')) {
    //         $('#sbs-agreement-tab').addClass('active');
    //     } else if (this.router.url.match('/fees')) {
    //         $('#fees-tab').addClass('active');
    //     } else if (this.router.url.match('/authorised-rep')) {
    //         $('#authorised-rep-tab').addClass('active');
    //     } else if (this.router.url.match('/assistant-trainer')) {
    //         $('#assistant-trainer-tab').addClass('active');
    //     } else if (this.router.url.match('/messaging-service')) {
    //         $('#messaging-service-tab').addClass('active');
    //     } else if (this.router.url.match('/prospective-owners')) {
    //         $('#prospective-owners-tab').addClass('active');
    //     } else if (this.router.url.match('/horses')) {
    //         $('#horses-tab').addClass('active');
    //     } else if (this.router.url.match('/employment')) {
    //         $('#employment-tab').addClass('active');
    //     } else if (this.router.url.match('/portfolio')) {
    //         $('#portfolio-tab').addClass('active');
    //     } else if (this.router.url.match('/employee-trainer')) {
    //         $('#employee-trainer-tab').addClass('active');
    //     } else if (this.router.url.match('/trainer-personnel')) {
    //         $('#personnel-trainer-tab').addClass('active');
    //     } else if (this.router.url.match('/trainer-experience')) {
    //         $('#trainer-experience-tab').addClass('active');
    //     }else if (this.router.url.match('/corporate')) {
    //         $('#corporate-tab').addClass('active');
    //     }
    //     localStorage.removeItem('valueChanges');
    // }

    activatedTab() {
        $('.nav-link').removeClass('active');
        if (this.router.url.match('/profile-details')) {
            $('#profile-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("profile-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/principal-yard')) {
            $('#principalYard-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("principalYard-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/additional-yard')) {
            $('#additionalYard-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("additionalYard-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/experience-pt-1')) {
            $('#experience-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("experience-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/fit-and-proper-person')) {
            $('#fitProperPerson-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("fitProperPerson-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/data-protection')) {
            $('#dataprotection-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("dataprotection-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/medical')) {
            $('#medical-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("medical-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/concussion')) {
            $('#concussion-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("concussion-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/fixtures')) {
            $('#fixtures-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("fixtures-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/fiscal')) {
            $('#fiscal-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("fiscal-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/insurance')) {
            $('#insurance-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("insurance-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/employee-card-1')) {
            $('#employee-card1-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("employee-card1-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/personnel')) {
            $('#personnel-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("personnel-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/facilities')) {
            $('#facilities-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("facilities-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/declaration')) {
            $('#declaration-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("declaration-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/summary')) {
            $('#summary-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("summary-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/sbs-agreement')) {
            $('#sbs-agreement-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("sbs-agreement-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/fees')) {
            $('#fees-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("fees-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/authorised-rep')) {
            $('#authorised-rep-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("authorised-rep-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/assistant-trainer')) {
            $('#assistant-trainer-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("assistant-trainer-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/messaging-service')) {
            $('#messaging-service-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("messaging-service-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/prospective-owners')) {
            $('#prospective-owners-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("prospective-owners-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/horses')) {
            $('#horses-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("horses-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/employment')) {
            $('#employment-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("employment-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/portfolio')) {
            $('#portfolio-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("portfolio-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/employee-trainer')) {
            $('#employee-trainer-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("employee-trainer-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/trainer-personnel')) {
            $('#personnel-trainer-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("personnel-trainer-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/trainer-experience')) {
            $('#trainer-experience-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("trainer-experience-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/corporate')) {
            $('#corporate-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("corporate-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        } else if (this.router.url.match('/education')) {
            $('#education-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("education-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        }
        else if (this.router.url.match('/post-interview')) {
            $('#post-interview-tab').addClass('active');
            var targetToScroll = <HTMLElement>document.getElementById("post-interview-tab");
            if (targetToScroll) {
                targetToScroll.scrollIntoView();
            }
        }

        localStorage.removeItem('valueChanges');
    }

    saveTab(tab) {
        localStorage.setItem('tab', tab);
        var valueChanges = JSON.parse(localStorage.getItem('valueChanges'));
        if (this.checkSubmitApplication === true) {
            this.router.navigate(['application-form/' + tab]);
        } else if (valueChanges === true) {
            if (this.router.url.match('/profile-details')) {
                $('#postPersonDetailsModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/experience-pt-1')) {
                $('#postExperienceModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/principal-yard')) {
                $('#postPrincipalYardModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/additional-yard')) {
                $('#postAdditionalYardModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/fit-and-proper-person')) {
                if (this.isRenewalApplication === false) {
                    $('#postFitAndProperPersonModal').modal({
                        backdrop: 'static',
                        keyboard: false
                    });
                } else {
                    if (this.currentApplicationDetails.licenceType == 'Trainer' || this.currentApplicationDetails.licenceType == 'Trainer - Rules of Racing (Flat)' || this.currentApplicationDetails.licenceType == 'Trainer - INHS Rules'
                        || this.currentApplicationDetails.licenceType == 'Trainer - Rules of Racing (Flat) and INHS Rules' || this.currentApplicationDetails.licenceType == 'Employee Trainer - Rules of Racing (Flat)' || this.currentApplicationDetails.licenceType == 'Employee Trainer - INHS Rules' || this.currentApplicationDetails.licenceType == 'Employee Trainer - Rules of Racing (Flat) and INHS Rules' ||
                        this.currentApplicationDetails.licenceType == 'Restricted - Rules of Racing (Flat)' || this.currentApplicationDetails.licenceType == 'Restricted - Rules of Racing (Flat) and INHS Rules'
                        || this.currentApplicationDetails.licenceType == 'Restricted - INHS Rules' || this.currentApplicationDetails.licenceType == 'Hunter Chase') {
                        $('#postFitAndProperPersonModal2').modal({
                            backdrop: 'static',
                            keyboard: false
                        });
                    } else {
                        $('#postExperienceModal').modal({
                            backdrop: 'static',
                            keyboard: false
                        });
                    }
                }
            } else if (this.router.url.match('/data-protection')) {
                $('#postConsentModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/medical')) {
                $('#postMedicalModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/concussion')) {
                $('#postConcussionModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/fixtures')) {
                $('#postFixturesModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/fiscal')) {
                $('#postFiscalModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/insurance')) {
                $('#postInsuranceModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/personnel')) {
                $('#postPersonnelModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/facilities')) {
                $('#postFacilitiesModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/declaration')) {
                $('#postDeclarationModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/summary')) {
                $('#postSummaryDataModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/fees')) {
                $('#postFeesDataModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/authorised-rep')) {
                $('#postAuthorisedRepsModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/sbs-agreement')) {
                $('#postSBSAgreementModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/messaging-service')) {
                $('#postMessagingServiceModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/assistant-trainer')) {
                $('#postAssistantTrainerModal2').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/employee-card-1')) {
                $('#postEmployeeCardModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/prospective-owners')) {
                $('#postProspectiveOwnersModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/horses')) {
                $('#postHorsesModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/employment')) {
                $('#postEmploymentModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/portfolio')) {
                $('#postPortfolioModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/trainer-personnel')) {
                $('#postPersonnelTrainerModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/trainer-experience')) {
                $('#postExperienceTrainerModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/corporate')) {
                $('#postCorporateModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.router.url.match('/education')) {
                $('#postEducationModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            }
        } else {
            this.router.navigate(['application-form/' + tab]);
        }
    }

    onActivate(event: any) {
        if (isPlatformBrowser(this.platformId)) {
            let scrollToTop = window.setInterval(() => {
                let pos = window.pageYOffset;
                if (pos > 0) {
                    window.scrollTo(0, 0);
                } else {
                    window.clearInterval(scrollToTop);
                }
            }, 16);
        }
    }

    progessbarHandler() {
        $('.next').click(function () {

            var nextId = $(this).parents('.tab-pane').next().attr("id");
            $('[href=#' + nextId + ']').tab('show');
            return false;

        });
        $('.back').click(function () {

            var prevId = $(this).parents('.tab-pane').prev().attr("id");
            $('[href=#' + prevId + ']').tab('show');
            return false;

        });

        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            //update progress
            var step = $(e.target).data('step');
            var percent = (parseInt(step) / 7) * 100;
            $('.progress-bar').css({ width: percent + '%' });
            $('.progress-bar').text('Step ' + step + ' of 7');
            //e.relatedTarget // previous tab
        });
    }

    getApplicationProgressData() {
        this.spinner.show();
        this.userService.getApplicationProgressService(this.token, this.currentApplicationDetails.licensingApplicationId).subscribe((data: any) => {
            this.spinner.hide();
            this.progessbarHandlerFun(data);
        }, error => {
            if (error.status === 200) {
                return;
            }
            this.spinner.hide();
        });

    }

    progessbarHandlerFun(data) {
        let applicationprogress = data.data;
        var step1 = applicationprogress.licensingApplicationSubmitted;
        var step2 = applicationprogress.applicationClaimed;
        var step3 = applicationprogress.setFees;
        var step4 = applicationprogress.sendToAccount;
        var step5 = applicationprogress.accountsClaimed;
        var step6 = applicationprogress.approvedByAccount;
        var step7 = applicationprogress.dispatchPhysicalLicence;
        var current_progress = 0;
        var current_step = 0;
        if (step1) {
            current_step = 1;
            current_progress = 16;
            $('#dynamic').addClass('bg-danger');
        }
        if (step2) {
            current_step = 2;
            current_progress += 14;
            $('#dynamic').addClass('bg-danger');
        }
        if (step3) {
            current_step = 3;
            current_progress += 14;
            $("#dynamic").removeClass('bg-danger');
            $('#dynamic').addClass('bg-warning');
        }
        if (step4) {
            current_step = 4;
            current_progress += 14;
            $('#dynamic').addClass('bg-warning');

        }
        if (step5) {
            current_step = 5;
            current_progress += 14;
            $('#dynamic').addClass('bg-warning');

        } if (step6) {
            current_step = 6;
            current_progress += 14;
            $('#dynamic').addClass('bg-warning');
        }
        if (step7) {
            current_step = 7;
            current_progress += 14;
            $("#dynamic").removeClass('bg-warning');
            $('#dynamic').addClass('bg-success');
        }

        $("#dynamic").css("width", current_progress + "%").attr("aria-valuenow", current_progress)
            .text("Step" + " " + current_step + " " + "of  7");

    }


}
